import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authHeader from "./authHeader";
import { apiInstance } from "./axiosApi";

export const getExamType = createAsyncThunk(
  "admin/allExamType",
  async ({ page, limit, searchData }, { rejectWithValue }) => {
    try {
      let url = `/exam-type/all?page=${page}&limit=${limit}`;
      if (searchData) {
        url += `&search=${searchData}`;
      }
      const response = await apiInstance.get(url, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getSingleExamType = createAsyncThunk(
  "admin/singleExamType",
  async (ExamId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`/exam-type/${ExamId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const addExamType = createAsyncThunk(
  "admin/addExamType",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/exam-type/add`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const editExamType = createAsyncThunk(
  "admin/editExamType",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/exam-type/edit`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteExamType = createAsyncThunk(
  "admin/deleteExamType",
  async (selectedId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.delete(
        `/exam-type/delete/${selectedId}`,
        {
          headers: authHeader(),
        }
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  examLoading: false,
};
const examTypeSlice = createSlice({
  name: "examTypeSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getExamType.fulfilled, (state, action) => {
      state.examTypeData = action.payload.data;
      state.examTypeLoading = false;
    });
    builder.addCase(getSingleExamType.fulfilled, (state, action) => {
      state.singleExamTypeData = action.payload.data;
    });
  },
});

export default examTypeSlice.reducer;
